import { getYesNoLabel } from '@Constants/selectOptions';
import { ApiExternalApplicationSecret, type ApiExternalApplication } from '@Model';
import { Column } from '@synqo/frontend-component-library';

export function padSecret(value: string) {
    if (value.length === 0) {
        return '';
    }

    if (value.length > 5) {
        return value;
    }

    return value.padEnd(20, '*');
}

export const externalApplicationColumns: Column<ApiExternalApplication>[] = [
    { name: 'label', label: 'Name' },
    {
        name: 'use_staged_import',
        label: 'Mit Schleuse',
        renderCell: ({ cellData }) => getYesNoLabel(cellData as boolean),
    },
];

export const externalApplicationSecretColumns: Column<ApiExternalApplicationSecret>[] = [
    { name: 'label', label: 'Name' },
    { name: 'expires_at', label: 'Gültig bis', type: 'date' },
    { name: 'value', label: 'Wert', renderCell: ({ cellData }) => padSecret(cellData as string) },
];
